<template>
  <el-card class="box-card mb-10" :loading="loading">
    <div
      id="qc3ChartContainer"
      :style="`min-height:${chartHeight || 500}px; width:${width || '100%'}`"
    ></div>
  </el-card>
</template>
<script>
import ChartHelper from "@/mixins/ChartsHelper";

import Highcharts from "@/config/highcharts";
window.qc3Chart = null;

export default {
  props: ["qc3Data", "width", "chartHeight"],
  mixins: [ChartHelper],
  data() {
    return {
      loading: false,
      mean: 7.14,
      stndDev: 2.1,
      cv: 1.2,
      chartData: {
        chart: {
          zoomType: "x",
        },
        scrollbar: {
          enabled: true,
          height: 10,
          showFull: false,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          labelFormat: "{name}",
          useHTML: true,
          width: "8%",
          marginTop: 5,
          borderWidth: 2,
          padding: 5,
          itemStyle: {
            color: "#000000",
            fontSize: "13px",
          },
        },
        plotOptions: {
          series: {
            events: {
              legendItemClick: function (e) {
                e.preventDefault();
              },
            },
          },
        },
        title: {
          text: "6-MAM 1 -- QC1",
        },
        subtitle: {
          text: "Mean: 7.14, STDEV: 0.361, CV: 5.05",
        },
        decimals: true,
        credits: {
          enabled: false,
        },
        yAxis: [
          {
            title: {
              text: "Concentration (ng/mL)",
            },
            allowDecimals: false,
            lineWidth: 2,
            gridLineWidth: 0,
            tickWidth: 2,
            showEmpty: true,
            min: 5,
            max: 10,
            tickInterval: 1,
            plotLines: [
              {
                color: "#AA5A5D", // Color value
                dashStyle: "Solid", // Style of the plot line. Default to solid
                value: 8.3, // Value of where the line will appear
                width: 1, // Width of the line
              },
              {
                color: "#71D273", // Color value
                dashStyle: "Solid", // Style of the plot line. Default to solid
                value: 7.5, // Value of where the line will appear
                width: 1, // Width of the line
              },

              {
                color: "#AA5A5D", // Color value
                dashStyle: "Solid", // Style of the plot line. Default to solid
                value: 6.1, // Value of where the line will appear
                width: 1, // Width of the line
              },
            ],
          },
          {
            title: {
              text: "Acceptance Criteria",
            },
            categories: ["-25%"],
            gridLineWidth: 0,
            offset: 0,
            lineWidth: 2,
            opposite: true,
          },
        ],
        tooltip: {
          pointFormat: "X - {point.category} <br/>",
          footerFormat: "Y - {point.y} <br/>",
        },
        xAxis: {
          categories: [],
          tickWidth: 2,
          tickmarkPlacement: "on",
          labels: {
            rotation: 290,
          },
          events: {
            afterSetExtremes: () => {},
          },
        },

        series: [
          {
            name: "Used",
            type: "scatter",
            data: [],
            marker: {
              enabled: true,
              radius: 4,
              symbol: "triangle",
              fillColor: "black",
            },
            zones: [
              {
                value: 15,
                upto: "lower",
                className: "zone-mean",
                color: "#FF0000",
              },
              {
                value: 20,
                upto: "upper",
                color: "#000",
              },
              {
                color: "#FF0000",
              },
            ],
          },
          {
            name: "Unused",
            color: "red",
            type: "scatter",
            data: [],
            marker: {
              enabled: true,
              symbol: "cross",
              radius: 4,
              lineColor: "red",
              lineWidth: 2,
            },
            legendIndex: 2,
          },
          {
            name: "&#177;20% of - <br> Target",
            legendIndex: 3,
            color: "#AA5A5D",
            marker: {
              symbol: "cross",
              lineColor: "#AA5A5D",
            },
          },
          {
            name: "Target - <br> Conc",
            legendIndex: 4,
            color: "#71D273",
            marker: {
              symbol: "cross",
              lineColor: "#71D273",
            },
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "downloadPNG",
                "downloadPDF",

                "separator",
                "downloadCSV",
              ],
            },
          },
        },
      },
    };
  },
  async mounted() {
    await this.prepareChartData();
  },
  methods: {
    prepareChartData() {
      this.loading = true;
      if (this.qc3Data.data) {
        let categories = this.qc3Data.data.map((e) => e.name);
        this.chartData.xAxis.categories = categories;

        this.qc3Data.data.forEach((element, index) => {
          if (element.used) {
            this.chartData.series[0].data.push([index, element.value]);
          } else {
            this.chartData.series[1].data.push([index, element.value]);
          }
        });

        this.chartData.series[0].zones[0].value = this.qc3Data.config.lower;
        this.chartData.series[0].zones[1].value = this.qc3Data.config.upper;

        this.chartData.yAxis[0].plotLines[0].value = this.qc3Data.config.upper;
        this.chartData.yAxis[0].plotLines[1].value = this.qc3Data.config.middle;
        this.chartData.yAxis[0].plotLines[2].value = this.qc3Data.config.lower;

        let min = this.getMinValue(
          this.qc3Data.config.lower,
          this.qc3Data.data
        );
        let max = this.getMaxValue(
          this.qc3Data.config.upper,
          this.qc3Data.data
        );

        this.chartData.yAxis[0].min = min - 50;
        this.chartData.yAxis[0].max = max + 10;
        this.chartData.yAxis[0].tickInterval = 5;

        this.chartData.xAxis.min = 0;
        this.chartData.xAxis.max = this.qc3Data.data.length - 1;

        this.chartData.title.text = `${this.qc3Data.drug} −− QCH`;

        this.mean = this.getMean(this.qc3Data.data);
        this.stndDev = this.getStandardDeviation(this.qc3Data.data);
        this.cv = this.stndDev / this.mean;

        this.chartData.subtitle.text = `Mean: ${this.mean.toFixed(
          2
        )}, STDEV: ${this.stndDev.toFixed(2)}, CV: ${this.cv.toFixed(2)}`;
        window.qc3Chart = Highcharts.chart("qc3ChartContainer", this.chartData);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss"></style>
